import React from 'react';
import dateformat from 'dateformat';

import * as S from './BkngDetailsBlock.styles';
import IconSelector from '@ibibo/icon-selector';

const BookingDetailFullBlock = ({data}) => {
  const {starRating, hotelName, address, city, country, pincode, phone, checkin, checkout, nights, rooms, roomType, inclusion, image, location} = data;
  
  const checkinDate = new Date(checkin.replace(/ /g,"T"));
  const checkoutDate = new Date(checkout.replace(/ /g,"T"));
  
  return(
    <>
      <S.BkngDetailInnerWrap>
        {(starRating && <S.BkngHotelStarWrap>
          <S.HtlStarWrap>{starRating}</S.HtlStarWrap>
        </S.BkngHotelStarWrap>) || null}

        <S.BkngHotelNameDetails>
          <S.BkngHtlNameText>{hotelName}</S.BkngHtlNameText>
          <S.BkngHtlAddressText>{address}, {city}, {country}, {pincode}</S.BkngHtlAddressText>
          <S.HtlContantInfoWrap>
            <S.ContactInfoIconWrap>
              <IconSelector iconKey='callhotel' />
            </S.ContactInfoIconWrap>
            {(phone && phone.length && <S.ContactInfoText>
              Contact : {phone.map((item, i) => {
                return <span key={`phone${i}`}>{i > 0 ? ', ' : ''}{item}</span>;
              })}
            </S.ContactInfoText>) || null}
          </S.HtlContantInfoWrap>
        </S.BkngHotelNameDetails>


        <S.BkngDetailCheckInfo>
          <S.CheckInfoWrap>
            <S.CheckInfoHeadText>CHECK-IN</S.CheckInfoHeadText>
            <S.CheckInfoDateWrap>
              <S.CheckInfoDateText>{dateformat(checkinDate, 'dd')}</S.CheckInfoDateText>
              <S.CheckDateInnerWrap>
                <S.CheckDateMonthText>{dateformat(checkinDate, 'mmm yyyy')}</S.CheckDateMonthText>
                <S.CheckTimeText>{dateformat(checkinDate, 'dddd')}, {dateformat(checkinDate, 'shortTime')}</S.CheckTimeText>
              </S.CheckDateInnerWrap>
            </S.CheckInfoDateWrap>
          </S.CheckInfoWrap>

          <S.StayNighsWrap>
            <S.DiagonalLine />
            <S.NightStayText>{nights}</S.NightStayText>
          </S.StayNighsWrap>

          <S.CheckInfoWrap>
            <S.CheckInfoHeadText>CHECK-Out</S.CheckInfoHeadText>
            <S.CheckInfoDateWrap>
              <S.CheckInfoDateText>{dateformat(checkoutDate, 'dd')}</S.CheckInfoDateText>
              <S.CheckDateInnerWrap>
                <S.CheckDateMonthText>{dateformat(checkoutDate, 'mmm yyyy')}</S.CheckDateMonthText>
                <S.CheckTimeText>{dateformat(checkoutDate, 'dddd')}, {dateformat(checkoutDate, 'shortTime')}</S.CheckTimeText>
              </S.CheckDateInnerWrap>
            </S.CheckInfoDateWrap>
          </S.CheckInfoWrap>
        </S.BkngDetailCheckInfo>

        <S.RoomTypeInfoWrap>
          <S.RoomTypeInfoHeadText>Room type</S.RoomTypeInfoHeadText>
          <S.RoomInfoInnerWrap>
            <S.RoomTypeText>{rooms} x {roomType}</S.RoomTypeText>
          </S.RoomInfoInnerWrap>
          <S.RoomInfoInnerWrap>
            {(inclusion && inclusion.length && inclusion.map((inclusion, i) => <S.RoomAmenitiesText key={`inclusion${i}`}>{i > 0 ? ',  ' : ''}{inclusion}</S.RoomAmenitiesText>)) || null}
          </S.RoomInfoInnerWrap>
        </S.RoomTypeInfoWrap>
      </S.BkngDetailInnerWrap>

      <S.BkngHotelImgWrap>
        <S.HotelImgTrip src={image} alt="hotel" />
        <S.ImageTextWrapper>{hotelName}</S.ImageTextWrapper>
        {/* <S.LocationImg src="https://cdn1.goibibo.com/t_g_ing_v8/justin-boutique-resort-goa-i39a3794-123114487948-orijgp.jpg" alt="location" /> */}
      </S.BkngHotelImgWrap>
    </>
  );
}

export default  BookingDetailFullBlock;